import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalConfigService } from './global-config.service';
import {
  IClinicApp,
  IClinicAppCreated,
  ICreateClinicAppRequest,
  IUpdateClinicAppScopesRequest
} from '../models/clinic-app.model';

@Injectable({
  providedIn: 'root'
})
export class ClinicAppService {

  private get baseUrl(): string {
    return this.globalConfig.getApiUrl() + '/clinic-apps';
  }

  constructor(
    private http: HttpClient,
    private globalConfig: GlobalConfigService
  ) {}

  /** Listar apps da clínica ativa */
  listApps(): Observable<IClinicApp[]> {
    return this.http.get<IClinicApp[]>(this.baseUrl);
  }

  /** Obter app por ID */
  getApp(id: string): Observable<IClinicApp> {
    return this.http.get<IClinicApp>(`${this.baseUrl}/${id}`);
  }

  /** Criar app */
  createApp(request: ICreateClinicAppRequest): Observable<IClinicAppCreated> {
    return this.http.post<IClinicAppCreated>(this.baseUrl, request);
  }

  /** Deleção lógica (soft delete) */
  deleteApp(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  /** Regenerar secret */
  regenerateSecret(id: string): Observable<IClinicAppCreated> {
    return this.http.put<IClinicAppCreated>(`${this.baseUrl}/${id}/regenerate-secret`, {});
  }

  /** Atualizar scopes */
  updateScopes(id: string, request: IUpdateClinicAppScopesRequest): Observable<IClinicApp> {
    return this.http.put<IClinicApp>(`${this.baseUrl}/${id}/scopes`, request);
  }
}
